import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { ApiUrl } from "../../Constants/Weburl";
import "../../CssPage/Livesettings.css";
import SettingSidebar from "../../components/Setttingsidebar";
import CustomContainer from "../../components/Customsettingscontain";
import CustomCard from "../../components/Customsettingscard";
import CustomInput from "../../components/Custominput";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";


export default function Admob() {
  const [settings, setSettings] = useState({
    androidBanner: "",
    androidInterstitial: "",
    iosBanner: "",
    iosInterstitial: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [enabled, setEnabled] = useState(false);
 
  useEffect(() => {
    fetchSettings();
  }, []);
 
  const fetchSettings = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const res = await axios.get(
        `${ApiUrl}api/admin/livestreamsettings`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        setSettings(res.data.data);
      }
    } catch (err) {
      console.log("fetchSettings error:", err);
    } finally {
      setLoading(false);
    }
  };
 
   const saveSettings = async () => {
  setSaving(true);

  try {
    const token = localStorage.getItem("adminToken");

    await axios.post(
      `${ApiUrl}admobsettings`,
      {
        androidBanner: settings.androidBanner,
        androidInterstitial: settings.androidInterstitial,
        androidEnabled: enabled,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setSaved(true);

    setTimeout(() => {
      setSaved(false);
    }, 2000);
  } catch (err) {
    console.log("saveSettings error:", err);
  } finally {
    setSaving(false);
  }
};
 
 
 
  return (
      <Layout>
           
           <SettingsPageShell wrapperClassName="rr-wrapper-admob">
 
          {/* <CustomContainer className="rr-wrapper-admob" bodyClassName=""> */}
             
               {loading ? (
                    <div className="ls-wrapper-admob">
                        <p>Loading...</p>
                    </div>
                ) : (
           
            <div className="ls-wrapper-admob">
              {/* ── Admin Setting Section ── */}
              <div className="ls-section-title">Admob</div>
 
              <div className="ls-grid-3">
                {/* Android Card */}
                <CustomCard bodyClassName="ls-card">
                  <h4>Android</h4>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={enabled}
                      onChange={(e) => setEnabled(e.target.checked)}
                    />
                    <span className="toggle-slider"></span>
                  </label>
 
                  <CustomInput
                    label="Banner Ad Unit"
                    wrapperClassName="first-block"
                    labelClassName="ls-label"
                    className="ls-input"
                    placeholder="ca-app-pub-3940256099942544/9214589741"
                    value={settings.androidBanner}
                    onChange={(e) =>
                      setSettings({ ...settings, androidBanner: e.target.value })
                    }
                  />
 
                  <CustomInput
                    label="Interstitial Ad Unit"
                    wrapperClassName="second-block"
                    labelClassName="ls-label"
                    className="ls-input"
                    placeholder="ca-app-pub-3940256099942544/9214589741"
                    value={settings.androidInterstitial}
                    onChange={(e) =>
                      setSettings({
                        ...settings,
                        androidInterstitial: e.target.value,
                      })
                    }
                  />
                </CustomCard>
 
                {/* iOS Card */}
                <CustomCard bodyClassName="ls-card">
                  <h4>IOS</h4>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={enabled}
                      onChange={(e) => setEnabled(e.target.checked)}
                    />
                    <span className="toggle-slider"></span>
                  </label>
 
                  <CustomInput
                    label="Banner Ad Unit"
                    wrapperClassName="first-block"
                    labelClassName="ls-label"
                    className="ls-input"
                    placeholder="ca-app-pub-3940256099942544/9214589741"
                    value={settings.iosBanner}
                    onChange={(e) =>
                      setSettings({ ...settings, iosBanner: e.target.value })
                    }
                  />
 
                  <CustomInput
                    label="Interstitial Ad Unit"
                    wrapperClassName="second-block"
                    labelClassName="ls-label"
                    className="ls-input"
                    placeholder="ca-app-pub-3940256099942544/9214589741"
                    value={settings.iosInterstitial}
                    onChange={(e) =>
                      setSettings({ ...settings, iosInterstitial: e.target.value })
                    }
                  />
                </CustomCard>
              </div>
 
              {/* Save Button */}
              <button
                className="ls-save-btn"
                onClick={saveSettings}
                disabled={saving}
              >
                {saving ? "Saving..." : saved ? "Saved!" : "Save"}
              </button>
            </div>
                )}
          {/* </CustomContainer> */}
        {/* </div> */}
        </SettingsPageShell>
        </Layout>
    
  );
}
